import React ,{useState,useEffect} from 'react'
import { useDispatch ,useSelector} from 'react-redux';
import DataTable from "../../Utils/GenericUI/DataTable";
import { APPOPINTMENT_TABLE_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import { fetchAppointments } from '../../Redux/Actions/webAppActions';
export default function Appointments(props) {
    const [state,setState]=useState({rowsPerPage:10,selectedRowIndex:0,});
    //const {appointments}=useSelector((state)=>state.campaignProspect)
    const { appointments } = useSelector((appState) => appState.campaignProspect);
    const handleChangeRowsPerPage =(rowsPerPage1) => {
      setState(() => ({
            ...state,
          rowsPerPage: rowsPerPage1,
        }));
      };
      const dispatch=useDispatch()
    useEffect(()=>{
        // const resp=await 
        dispatch(fetchAppointments(leadIdNbr))
        // console.log("resp-",leadIdNbr,tiiiii)
        // setState({...state,appointments:[]})
    },[])
      const {rowsPerPage,selectedRowIndex}=state;
      const {leadIdNbr}=props;
  return (
    <>
    <DataTable
    width="100%"
    dashboard="prospectManagement"
    padding="4px 40px 4px 4px"
    data={appointments}
    header={header}
    //exportAsExcel={true}
    rowsPerPage={rowsPerPage}
    rowsPerPageOptions={[10, 15, 20]}
    index={selectedRowIndex}
    handleChangeRowsPerPage={handleChangeRowsPerPage}
    sortable={true}
    searchable={true}
    clicked={()=>{}}
    setClick={()=>{}}
    identifier="appointmentsTable"
    />
    </>
  )
}
